module.exports = __webpack_public_path__ + "img/copilot-static.0e18c2bb.png";